export const sections = {
  // ----- Business sub-pages ------------------------------------------------
  // The original /manage/business landing was split into four standalone
  // pages — Account (identity + theme), Address, Schedule, Customer notes.
  // Each child registers here so the parent landing and the global search
  // index pick them up consistently.
  businessAccount: {
    label: 'general.account',
    icon: 'lucide:building-2',
    info: 'manage.landings.business.accountInfo',
    path: '/manage/business/account',
    tags: ['business', 'name', 'email', 'phone', 'timezone', 'time zone', 'locale', 'currency', 'logo', 'theme', 'colour', 'color', 'customer name', 'identity', 'date format', 'language'],
  },
  businessAddress: {
    label: 'general.address',
    icon: 'lucide:map-pin',
    info: 'manage.landings.business.addressInfo',
    path: '/manage/business/address',
    tags: ['address', 'city', 'region', 'postcode', 'country', 'location'],
  },
  businessSchedule: {
    label: 'general.schedule',
    icon: 'lucide:calendar-clock',
    info: 'manage.landings.business.scheduleInfo',
    path: '/manage/business/schedule',
    tags: ['calendar', 'bookings', 'timeline', 'slot size', 'start', 'week', 'time', 'threshold', 'time format', 'start day', 'schedule', 'block size'],
  },
  businessNotes: {
    label: 'manage.landings.business.notesLabel',
    icon: 'lucide:notebook-pen',
    info: 'manage.landings.business.notesInfo',
    path: '/manage/business/notes',
    tags: ['notes', 'customer notes', 'notes formula', 'notes template'],
  },
  businessTerminology: {
    label: 'manage.landings.business.terminologyLabel',
    icon: 'lucide:type',
    info: 'manage.landings.business.terminologyInfo',
    path: '/manage/business/terminology',
    tags: ['terminology', 'terms', 'rename', 'singular', 'plural', 'wording', 'labels', 'language'],
  },
  employees: {
    label: 'general.employees',
    icon: 'lucide:users',
    info: 'components.manage.pages.sections.employees',
    path: '/manage/team/employees',
    tags: ['contract', 'employees', 'users', 'settings', 'services', 'overrides', 'staff', 'team', 'chairs', 'therapist', 'personnel', 'practitioner', 'bookable'],
    term: 'employee',
  },
  resources: {
    label: 'general.resources',
    icon: 'lucide:boxes',
    info: 'components.manage.pages.sections.resources',
    path: '/manage/resources/list',
    tags: ['assets', 'pool', 'materials', 'rooms', 'tools', 'equipment', 'mcahines'],
  },
  resourceGroups: {
    label: 'general.resourceGroups',
    icon: 'lucide:layers',
    info: 'components.manage.pages.sections.resourcesGroups',
    path: '/manage/resources/groups',
    tags: ['assets', 'pool', 'materials', 'rooms', 'tools', 'equipment', 'type', 'category'],
  },
  services: {
    label: 'general.services',
    icon: 'lucide:scissors',
    info: 'components.manage.pages.sections.services',
    path: '/manage/services/list',
    tags: ['classes', 'sessions', 'bookings', 'options', 'treatments', 'menu', 'therapies'],
  },
  serviceCategories: {
    label: 'manage.pages.serviceCategories',
    icon: 'lucide:folder-open',
    info: 'components.manage.pages.sections.serviceCategories',
    path: '/manage/services/categories',
    tags: ['classes', 'sessions', 'bookings', 'options', 'groups', 'section', 'sort', 'types'],
  },
  statusTypes: {
    label: 'manage.pages.statusTypes',
    icon: 'lucide:circle-dot',
    info: 'components.manage.pages.sections.statusTypes',
    path: '/manage/services/status-types',
    tags: ['status', 'tags', 'flags'],
  },
  cancellationReasons: {
    label: 'manage.pages.cancellationReasons',
    icon: 'lucide:x-circle',
    info: 'components.manage.pages.sections.cancellationReasons',
    path: '/manage/services/cancellation-reasons',
    tags: ['cancel', 'cancellation', 'reason', 'remove', 'notes', 'flags'],
  },
  products: {
    label: 'general.products',
    icon: 'lucide:package',
    info: 'components.manage.pages.sections.products',
    path: '/manage/products/list',
    tags: ['items', 'goods', 'merchandise', 'inventory', 'retail', 'stock'],
  },
  productCategories: {
    label: 'manage.pages.productCategories',
    icon: 'lucide:tags',
    info: 'components.manage.pages.sections.productCategories',
    path: '/manage/products/categories',
    tags: ['group', 'section', 'sort', 'type'],
  },
  brands: {
    label: 'manage.pages.brands',
    icon: 'lucide:award',
    info: 'components.manage.pages.sections.brands',
    path: '/manage/products/brands',
    tags: ['make', 'variety', 'manufacturer'],
  },
  suppliers: {
    label: 'manage.pages.suppliers',
    icon: 'lucide:truck',
    info: 'components.manage.pages.sections.suppliers',
    path: '/manage/products/suppliers',
    tags: ['make', 'variety', 'manufacturer', 'vendor'],
  },
  purchaseOrders: {
    label: 'general.purchaseOrders',
    icon: 'lucide:clipboard-list',
    info: 'components.manage.pages.sections.purchaseOrders',
    path: '/manage/products/purchase-orders',
    tags: ['types', 'quantity', 'price', 'seller', 'document', 'PO'],
  },
  stockTake: {
    label: 'general.stockTake',
    icon: 'lucide:clipboard-check',
    info: 'components.manage.pages.sections.stockTake',
    path: '/manage/products/stock-take',
    tags: ['inventory', 'checking', 'counting', 'wall', 'audit'],
  },
  taxes: {
    label: 'general.taxes',
    icon: 'lucide:receipt',
    info: 'components.manage.pages.sections.taxes',
    path: '/manage/sales-setup/taxes',
    tags: ['levy', 'tariff', 'duty', 'toll', 'sales', 'VAT', 'GST', 'PST'],
  },
  details: {
    label: 'general.details',
    icon: 'lucide:file-text',
    info: 'components.manage.pages.sections.details',
    path: '/manage/sales-setup',
    tags: ['sales', 'details', 'receipt', 'tax'],
  },
  customFieldsCustomer: {
    label: 'general.customer',
    icon: 'lucide:contact',
    info: 'components.manage.pages.sections.customFieldsCustomer',
    path: '/manage/custom-fields/customer',
    tags: ['input', 'entry', 'data', 'customer'],
  },
  customFieldsReservation: {
    label: 'general.appointment',
    icon: 'lucide:notebook-pen',
    info: 'components.manage.pages.sections.customFieldsReservation',
    path: '/manage/custom-fields/reservation',
    tags: ['input', 'entry', 'data'],
  },
  customFieldsReservationCustomer: {
    label: 'manage.pages.classCustomer',
    icon: 'lucide:users',
    info: 'components.manage.pages.sections.customFieldsReservationCustomer',
    path: '/manage/custom-fields/reservationCustomer',
    tags: ['input', 'entry', 'data', 'attendee', 'customer'],
  },
  customFieldsSale: {
    label: 'general.sale',
    icon: 'lucide:shopping-cart',
    info: 'components.manage.pages.sections.customFieldsSale',
    path: '/manage/custom-fields/order',
    tags: ['input', 'entry', 'data', 'sale', 'order', 'purchase'],
  },
  customFieldsEmployee: {
    label: 'general.employee',
    icon: 'lucide:user-cog',
    info: 'components.manage.pages.sections.customFieldsEmployee',
    path: '/manage/custom-fields/employee',
    tags: ['input', 'entry', 'data', 'employee'],
  },
  customFieldsService: {
    label: 'general.service',
    icon: 'lucide:wrench',
    info: 'components.manage.pages.sections.customFieldsService',
    path: '/manage/custom-fields/service',
    tags: ['input', 'entry', 'data', 'service'],
  },
  customFieldsProducts: {
    label: 'general.product',
    icon: 'lucide:package-search',
    info: 'components.manage.pages.sections.customFieldsProduct',
    path: '/manage/custom-fields/product',
    tags: ['input', 'entry', 'data', 'product'],
  },
  forms: {
    label: 'general.forms',
    icon: 'lucide:clipboard-pen-line',
    info: 'components.manage.pages.sections.forms',
    path: '/manage/forms',
    tags: ['forms', 'screening', 'collect', 'survey', 'consultation', 'questionnaire', 'SOAP', 'intake', 'medical history', 'contraindications', 'consent', 'declaration', 'disclaimer', 'health', 'signature', 'aftercare'],
  },
  customerGiftCards: {
    label: 'manage.pages.customerGiftCards',
    icon: 'lucide:gift',
    info: 'components.manage.pages.sections.customerGiftCards',
    path: '/manage/loyalty-and-promotions/customer-gift-cards',
    tags: ['present', 'voucher', 'certificate', 'purchase', 'coupon'],
  },
  passes: {
    label: 'general.passes',
    icon: 'lucide:ticket',
    info: 'components.manage.pages.sections.passes',
    path: '/manage/loyalty-and-promotions/pass',
    tags: ['location', 'pass', 'discount', 'voucher', 'class', 'course', 'membership'],
  },
  customerPasses: {
    label: 'manage.pages.customerPasses',
    icon: 'lucide:ticket',
    info: 'components.manage.pages.sections.customerPasses',
    path: '/manage/loyalty-and-promotions/customer-pass',
    tags: ['location', 'pass', 'discount', 'voucher', 'class', 'active'],
  },
  loyaltyProgram: {
    label: 'manage.pages.loyaltyProgramSettings',
    icon: 'lucide:star',
    info: 'components.manage.pages.sections.loyaltyProgram',
    path: '/manage/loyalty-and-promotions',
    tags: ['scheme', 'points', 'reward', 'loyalty', 'points', 'program'],
  },
  activeVouchers: {
    label: 'manage.pages.activeVouchers',
    icon: 'lucide:ticket-check',
    info: 'components.manage.pages.sections.activeVouchers',
    path: '/manage/loyalty-and-promotions/promo-codes?filter=unexpired',
    aliases: ['/manage/loyalty-and-promotions/active-promo-codes'],
    tags: ['discount', 'coupon', 'ticket', 'voucher', 'promotion', 'special'],
  },
  expiredVouchers: {
    label: 'manage.pages.expiredVouchers',
    icon: 'lucide:ticket-x',
    info: 'components.manage.pages.sections.expiredVouchers',
    path: '/manage/loyalty-and-promotions/promo-codes?filter=expired',
    aliases: ['/manage/loyalty-and-promotions/expired-promo-codes'],
    tags: ['discount', 'coupon', 'ticket', 'voucher', 'promotion'],
  },
  discounts: {
    label: 'general.discounts',
    icon: 'lucide:percent',
    info: 'components.manage.pages.sections.discounts',
    path: '/manage/sales-setup/discounts',
    tags: ['discount', 'coupon', 'preset', 'sale', 'order', 'purchase'],
  },
  charges: {
    label: 'order.charges',
    icon: 'lucide:circle-plus',
    info: 'components.manage.pages.sections.charges',
    path: '/manage/sales-setup/charges',
    tags: ['charge', 'coupon', 'preset', 'sale', 'order', 'purchase', 'fees'],
  },
  payments: {
    label: 'general.payments',
    icon: 'lucide:credit-card',
    info: 'components.manage.pages.sections.payments',
    path: '/manage/sales-setup/payments',
    tags: ['payments', 'coupon', 'preset', 'sale', 'order', 'purchase'],
  },
  templates: {
    label: 'manage.pages.templates',
    icon: 'lucide:file-code',
    info: 'components.manage.pages.sections.templates',
    path: '/manage/communications/templates',
    tags: ['templates', 'email', 'preset', 'document', 'notification', 'automated'],
  },
  email: {
    label: 'general.email',
    icon: 'lucide:mail',
    info: 'components.manage.pages.sections.email',
    path: '/manage/communications/email',
    tags: ['email', 'template', 'passbook', 'gmail', 'notification', 'automated'],
  },
  sms: {
    label: 'general.sms',
    icon: 'lucide:smartphone',
    info: 'components.manage.pages.sections.sms',
    path: '/manage/communications/sms',
    tags: ['sms', 'number', 'system', 'country', 'credits', 'pricing', 'text', 'messages'],
  },
  reminders: {
    label: 'general.reminders',
    icon: 'lucide:bell',
    info: 'components.manage.pages.sections.reminders',
    path: '/manage/communications/reminders',
    tags: ['appointment', 'sms', 'birthday', 'alert', 'notification', 'automated', 'text', 'messages'],
  },
  segments: {
    label: 'general.segments',
    icon: 'lucide:pie-chart',
    info: 'components.manage.pages.sections.segments',
    path: '/manage/marketing/segments',
    tags: ['customer', 'segments', 'group', 'category', 'tag', 'VIP'],
  },
  courses: {
    label: 'general.courses',
    icon: 'lucide:graduation-cap',
    info: 'components.manage.pages.sections.courses',
    path: '/manage/courses',
    tags: ['classes', 'sessions', 'bookings', 'options', 'treatments', 'menu', 'therapies'],
  },
  courseTypes: {
    label: 'general.courseTypes',
    icon: 'lucide:graduation-cap',
    info: 'components.manage.pages.sections.courseTypes',
    path: '/manage/course-types',
    tags: ['classes', 'sessions', 'bookings', 'options', 'treatments', 'menu', 'therapies', 'type', 'category'],
  },
  aftercareTemplates: {
    label: 'general.aftercareTemplates',
    icon: 'lucide:sparkles',
    info: 'components.manage.pages.sections.aftercareTemplates',
    path: '/manage/services/aftercare-templates',
    tags: ['automations', 'services', 'bookings', 'options', 'treatments', 'menu', 'therapies'],
  },
}

export const groups = [
  {
    label: '',
    items: [
      {
        label: 'general.preferences',
        icon: 'lucide:settings',
        path: '/manage/business/account',
        info: 'components.manage.pages.pages.preferences',
        children: [
          sections.businessAccount,
          sections.businessAddress,
          sections.businessSchedule,
          sections.businessNotes,
          sections.businessTerminology,
        ],
      },
      sections.employees,
      {
        label: 'general.services',
        icon: 'lucide:scissors',
        path: '/manage/services',
        info: 'components.manage.pages.pages.services',
        term: 'service',
        children: [
          sections.services,
          sections.serviceCategories,
          sections.statusTypes,
          sections.cancellationReasons,
          sections.aftercareTemplates,
        ],
      },
      {
        label: 'general.courses',
        icon: 'lucide:graduation-cap',
        path: '/manage/courses',
        info: 'components.manage.pages.sections.courses',
        term: 'course',
        children: [
          sections.courses,
          sections.courseTypes,
        ],
      },
      {
        label: 'manage.pages.resources',
        icon: 'lucide:boxes',
        path: '/manage/resources/list',
        info: 'components.manage.pages.pages.resources',
        children: [
          sections.resources,
          sections.resourceGroups,
        ],
      },
      {
        label: 'manage.pages.remindersAndNotifications',
        icon: 'lucide:bell',
        path: '/manage/communications/reminders',
        info: 'components.manage.pages.pages.remindersAndNotifications',
        children: [
          sections.reminders,
          sections.sms,
          sections.templates,
          sections.email,
        ],
      },
      sections.forms,
      {
        label: 'general.products',
        icon: 'lucide:package',
        path: '/manage/products',
        info: 'components.manage.pages.pages.products',
        term: 'product',
        children: [
          sections.products,
          sections.productCategories,
          sections.brands,
          sections.suppliers,
          sections.purchaseOrders,
          sections.stockTake,
        ],
      },
      {
        label: 'manage.pages.pointOfSale',
        icon: 'lucide:credit-card',
        path: '/manage/sales-setup',
        info: 'components.manage.pages.pages.pointOfSale',
        children: [
          sections.details,
          sections.taxes,
          sections.discounts,
          sections.charges,
          sections.payments,
        ],
      },
      {
        label: 'general.giftCards',
        icon: 'lucide:gift',
        path: '/manage/loyalty-and-promotions/customer-gift-cards',
        info: 'components.manage.pages.pages.customerGiftCards',
        term: 'giftCard',
        children: [
          sections.customerGiftCards,
        ],
      },
      {
        label: 'general.passes',
        icon: 'lucide:ticket',
        path: '/manage/loyalty-and-promotions/pass',
        info: 'components.manage.pages.pages.passes',
        children: [
          sections.passes,
          sections.customerPasses,
        ],
      },
      {
        label: 'manage.pages.promoCodes',
        icon: 'lucide:ticket-percent',
        path: '/manage/loyalty-and-promotions/promo-codes?filter=unexpired',
        info: 'components.manage.pages.pages.promoCodes',
        children: [
          sections.activeVouchers,
          sections.expiredVouchers,
        ],
      },
      {
        label: 'manage.pages.loyaltyProgram',
        icon: 'lucide:star',
        path: '/manage/loyalty-and-promotions',
        info: 'components.manage.pages.pages.loyaltyPoints',
        children: [
          sections.loyaltyProgram,
        ],
      },
      sections.segments,
      {
        label: 'general.customFields',
        icon: 'lucide:list',
        path: '/manage/custom-fields/customer',
        info: 'components.manage.pages.pages.customFields',
        children: [
          sections.customFieldsCustomer,
          sections.customFieldsReservation,
          sections.customFieldsReservationCustomer,
          sections.customFieldsSale,
          sections.customFieldsEmployee,
          sections.customFieldsService,
          sections.customFieldsProducts,
        ],
      },
    ],
  },
]
